// POST /paymentrequest/public/createintent
export const CREATE_PUBLIC_MANUAL_PAYMENT_INTENT =
  "CREATE_PUBLIC_MANUAL_PAYMENT_INTENT";
export const CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_SUCCESS =
  "CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_SUCCESS";
export const CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_FAILURE =
  "CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_FAILURE";
export const RESET_PUBLIC_MANUAL_PAYMENT_INTENT =
  "RESET_PUBLIC_MANUAL_PAYMENT_INTENT";
